import { END, eventChannel } from 'redux-saga';
import { call, put, take, takeLatest } from 'redux-saga/effects';
import { GET_WATCH_LIST, WATCH_GAME } from './constants';
import { setWatched, setWatchList } from './actions';
import { log, watched, watchList } from '../services/game';
import { setupPusher } from '../services/pusher';
import { ensureCards } from '../Cards/sagas';
import history from '../history';

function* getWatchListTask() {
  yield call(ensureCards);
  yield put(setWatchList(yield call(watchList)));
}

function* load(gameId) {
  const game = yield call(watched, gameId);
  const entries = yield call(log, gameId);
  yield put(setWatched(game, entries));
}

// The game's shared channel says when anything changes (it carries no hand); the table is loaded again then, the
// same way it was the first time, until you leave the page.
function* watchGameTask(action) {
  const { gameId } = action.payload;
  yield call(ensureCards);
  yield call(load, gameId);

  const echo = yield call(setupPusher);
  const changes = eventChannel((emit) => {
    echo.private(`game.${gameId}`).listen('GameUpdate', () => emit(true));
    const stop = history.listen(() => emit(END));
    return () => {
      stop();
      echo.disconnect();
    };
  });
  while (true) {
    yield take(changes);
    yield call(load, gameId);
  }
}

export default [
  function* watchListWatcher() { yield takeLatest(GET_WATCH_LIST, getWatchListTask); },
  function* watchGameWatcher() { yield takeLatest(WATCH_GAME, watchGameTask); },
];
